var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{attrs:{"icon":[_vm.type, _vm.icon],"size":_vm.size,"border":_vm.border,"flip":_vm.flip,"rotation":_vm.rotation,"inverse":_vm.inverse,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }